/**
 * Layout tokens - responsive max-width breakpoints for content containers
 */

export const MAX_WIDTH_XS = '95vw' as const;
export const MAX_WIDTH_SM = '85vw' as const;
export const MAX_WIDTH_MD = '70vw' as const;
export const MAX_WIDTH_LG = '850px' as const;
